


















































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { openOttoPay } from '@/utils/ottoPay'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { debounce, get, take, isEmpty, padStart } from 'lodash-es'
import Multiselect from 'vue-multiselect'
import moment from 'moment-timezone'
import { formatNumber, formatCurrency, getRequestId, formatCouponText, calculateLevelInfo, getEdcMidMapping } from '@/utils/helpers'
import api from '@/api'
import apiPathConst from '@/api/modules/apiPath'
import constants from '@/utils/constants'
import countryData from '@/utils/country'
import ConfirmModal from './ConfirmModal.vue'
import CurrencyInput from './CurrencyInput.vue'
import CouponList from './CouponList/CouponList.vue'
import CountrySelector from '@/components/CountrySelector/CountrySelector.vue'
import SimpleKeyboard from '@/components/SimpleKeyboard/index.vue'
import LoadingWithText from '@/components/LoadingWithText.vue'
import PosOrderModal from '@/components/PosOrderModal.vue'
import Autocomplete from '@/components/Autocomplete.vue'
import PinCode from './PinCode/index.vue'

@Component({
  components: {
    Multiselect,
    ConfirmModal,
    CurrencyInput,
    CouponList,
    CountrySelector,
    SimpleKeyboard,
    LoadingWithText,
    PosOrderModal,
    Autocomplete,
    PinCode
  },
  filters: {
    formatPrice(val: any) {
      let date: any = val
      return formatNumber(date)
    }
  }
})
export default class PosOrderTypeWithEDCStep extends Vue {
  @Prop() hidePosOrder!: any
  @Prop() modelType?: string | null
  @Prop(Function) reload!: Function
  @Prop(Function) handleClickOrderStatus!: Function
  @Prop(Function) switchOrderType!: Function
  public payment: string = ''
  public customerName: string = ''
  public isEditingName: boolean = false
  public originalCustomerName: string = ''
  public phoneNumber: string = ''
  public customerNote: string = ''
  public isEditingNote: boolean = false
  public useSearchMode: boolean = false
  public showDetail: boolean = false
  public paymentDetail: any = {}
  public discount_name: string = ''
  public has_processing_fee: number = 0
  public showProcessingFee: boolean = false
  public showSubTotal: boolean = false
  public country: any = countryData[0]
  public validPhone: boolean = true
  public options: Array<any> = []
  public qrisOptions: Array<any> = []
  public cardOptions: Array<any> = []
  public otherOptions: Array<any> = []
  public selectedPayment: object = {}
  public submitLoading: boolean = false
  public orderRequestId: string = ''
  public custom_total_payment: number = 0
  public total_payment: string = '0'
  public processing_fee: number = 0
  public constants: any = constants
  public payment_method: string = ''
  public debounceCalculate
  public isCalculating: boolean = false
  public fetchingCoupons: boolean = false
  public coupon: any = {}
  public showCouponModal: boolean = false
  public coupons: Array<any> = []
  public bannerImage: string = ''
  public steps: Array<any> = constants.DEFAULT_HOME_SCREEN_STEPS
  public currentStep: string = constants.HOME_SCREEN_STEPS_CONFIG.transaksiMember.key
  public userChecking: boolean = false
  public userRegistering: boolean = false
  public showTaggingModal: boolean = false
  public showEditNoteModal: boolean = false
  public skipCoupon: boolean = false
  public addFullNewUser: boolean = false
  public isNewUser: boolean = false
  public userRegistered: boolean = false
  public registeredInfo: any = {}
  public milestoneData: any = null
  public showTagging: number = 0
  public showBirthdate: number = 0
  public birthdate: any = {}
  public gender: number = 0
  public ageRange: string = ''
  public ageRangeOptions: Array<string> = []
  public genderTaggingActive: number = 0
  public ageRangeTaggingActive: number = 0
  public memberStatusTaggingActive: number = 0
  public ethnicityTagging: any = {
    active: false,
    options: [],
    value: ''
  }
  public occasionTagging: any = {
    active: false,
    options: [],
    value: []
  }
  public treatmentTagging: any = {
    active: false,
    options: [],
    value: []
  }
  public foodPreferenceTagging: any = {
    active: false,
    options: [],
    value: []
  }
  public memberStatus: number = 0
  public showPosOrderPopup: boolean = false
  public posOrderId: string = ''
  public formatCouponText: Function = formatCouponText
  public formatCurrency: Function = formatCurrency
  public keyboradLayout: Array<string> = [
    `1 2 3`,
    `4 5 6`,
    `7 8 9`,
    `000 0 {bksp}`
  ]
  public storeConfiguration = {}
  public userNoteActive: boolean = false
  public phoneInputRequired: boolean = false
  public brandNewCustomerTreatment: boolean = false
  public brandNew: boolean = false
  $swal: any
  apiPathConst: any = apiPathConst

  get isTestMode() {
    return sessionStorage.getItem('is-test-mode') === 'true'
  }

  get backHidden() {
    if (this.currentStep === this.steps[1].key) {
      return true
    }
    return (
      this.currentStep === constants.HOME_SCREEN_STEPS_CONFIG.posOrderPhone.key &&
      this.modelType === constants.EDC_ORDER_MODEL.checkCoupon
    )
  }

  get nextDisabled() {
    if (
      this.currentStep === constants.HOME_SCREEN_STEPS_CONFIG.totalPayment.key &&
      !this.custom_total_payment
    ) {
      return true
    }
    if (
      this.currentStep === constants.HOME_SCREEN_STEPS_CONFIG.posOrderPhone.key &&
      (!this.phoneNumber || !this.validPhone)
    ) {
      return true
    }
    return false
  }

  get nextLoading() {
    return (
      this.currentStep === constants.HOME_SCREEN_STEPS_CONFIG.posOrderPhone.key &&
      this.userChecking
    )
  }

  get genderOptions() {
    return constants.TAGGING_GENDER
  }

  get getYearOptions() {
    return Array.from(Array(new Date().getFullYear() - 1900).keys())
      .map(i => ({
        text: (i + 1900).toString(),
        value: (i + 1900).toString()
      }))
      .reverse()
  }

  get getMonthOptions() {
    return Array.from(Array(12).keys()).map(i => ({
      text: (i + 1).toString(),
      value: (i + 1).toString()
    }))
  }

  get getDayOptions() {
    return Array.from(Array(31).keys()).map(i => ({
      text: (i + 1).toString(),
      value: (i + 1).toString()
    }))
  }

  get topTitle() {
    if (this.modelType === constants.EDC_ORDER_MODEL.checkCoupon) {
      return 'Cek Member'
    }
    const modeTitle = this.isTestMode ? ' - Simulasi' : ''
    switch (this.currentStep) {
      case constants.HOME_SCREEN_STEPS_CONFIG.memberEDC.key:
        return `Member EDC ${modeTitle}`
      case constants.HOME_SCREEN_STEPS_CONFIG.totalPayment.key:
        return `Masukkan Total Pembayaran`
    }
    return `Pos Order ${modeTitle}`
  }

  get isCheckCoupon() {
    return this.modelType === constants.EDC_ORDER_MODEL.checkCoupon
  }

  get disableCheckout() {
    return this.isCheckCoupon
  }

  get outletCode() {
    const posOrderOutlet = JSON.parse(
      localStorage.getItem('pos-order-outlet') || '{}'
    )
    return posOrderOutlet.value.toString()
  }

  get shouldShowUserCard() {
    if (!this.userRegistered || !this.registeredInfo.name) {
      return false
    }

    const phoneStepIndex = this.steps.findIndex(
      step => step.key === constants.HOME_SCREEN_STEPS_CONFIG.posOrderPhone.key
    )
    const currentStepIndex = this.getCurrentStepIndex()

    // Show card after phone step and not on phone step itself
    return currentStepIndex > phoneStepIndex && phoneStepIndex !== -1
  }

  selectPhone(item) {
    this.phoneNumber = ''
    if (item && item.phoneNumber) {
      const numberArr = item.phoneNumber.split('-')
      if (numberArr.length > 1) {
        const getCountry = countryData.find(v => v.code === numberArr[0])
        if (getCountry) {
          this.country = getCountry
          this.phoneNumber = numberArr[1]
        }
      }
    }
  }

  handleAddFullUser(data) {
    this.showTaggingModal = true
    this.isNewUser = true
    this.addFullNewUser = true
    this.customerName = data.customerName
    this.country = countryData.find(v => v.code === data.countryCode) || countryData[0]
    this.phoneNumber = data.phoneNumber
  }

  changeInputType(domId) {
    const inputDom = this.$refs[domId]
    if (inputDom) {
      ;(inputDom as any).$refs.search.type = 'tel'
    }
  }

  checkBirthdate() {
    const yearString = padStart(
      this.birthdate.year ? this.birthdate.year.value : '',
      4,
      '0'
    )
    const monthString = padStart(
      this.birthdate.month ? this.birthdate.month.value : '',
      2,
      '0'
    )
    const dayString = padStart(
      this.birthdate.day ? this.birthdate.day.value : '',
      2,
      '0'
    )
    return (
      (this.birthdate.year || this.birthdate.month || this.birthdate.day) &&
      !moment(
        `${yearString}-${monthString}-${dayString}`,
        'YYYY-MM-DD'
      ).isValid()
    )
  }

  onSelectGender(item) {
    this.gender = item.value
  }

  onSelectAgeRange(value) {
    this.ageRange = value
  }

  onSelectEthnicity(value) {
    this.ethnicityTagging.value = value
  }

  handleMultipleSelection(target: { value: any[] }, value: any) {
    const index = target.value.indexOf(value)
    if (index > -1) {
      target.value.splice(index, 1)
    } else {
      target.value.push(value)
    }
  }

  onSelectOccasion(value) {
    if (this.occasionTagging.isMultiple) {
      this.handleMultipleSelection(this.occasionTagging, value)
    } else {
      this.occasionTagging.value = [value]
    }
  }

  onSelectTreatmentPreferences(value) {
    if (this.treatmentTagging.isMultiple) {
      this.handleMultipleSelection(this.treatmentTagging, value)
    } else {
      this.treatmentTagging.value = [value]
    }
  }

  onSelectFoodPreference(value) {
    this.handleMultipleSelection(this.foodPreferenceTagging, value)
  }

  onSelectMemberStatus(value) {
    this.memberStatus = value
  }

  editUserNote() {
    this.showEditNoteModal = true
  }

  saveEditNote() {
    this.showEditNoteModal = false
    // Note will be saved when submitting the order
  }

  setCountry(item) {
    this.country = item
  }

  toggleInputMode() {
    this.useSearchMode = !this.useSearchMode
    // Clear input when switching modes
    this.phoneNumber = ''
    this.customerName = ''
    this.userRegistered = false
    this.registeredInfo = {}
    // Clear autocomplete search box if exists
    if (this.useSearchMode && this.$refs.autocompleteSearch) {
      this.$nextTick(() => {
        const autocomplete = this.$refs.autocompleteSearch as any
        if (autocomplete && autocomplete.setValue) {
          autocomplete.setValue('')
        }
      })
    }
  }

  created() {
    this.debounceCalculate = debounce(this.calculateOrder, 500)
  }

  intoView(e) {
    if (e && e.srcElement) {
      setTimeout(() => {
        e.srcElement.scrollIntoView({
          behavior: 'smooth',
          block: 'end'
        })
      }, 500)
    }
  }

  onCancel() {
    this.showTaggingModal = false
    this.isNewUser = false
    this.isEditingNote = false
    // Roll back any name edit (in-progress or locally confirmed) because the
    // backend update only happens on the outer onConfirm; cancelling the modal
    // means nothing was committed.
    this.customerName = this.originalCustomerName
    this.isEditingName = false
  }

  enableNoteEdit() {
    this.isEditingNote = true
  }

  confirmNoteEdit() {
    this.isEditingNote = false
  }

  enableNameEdit() {
    this.isEditingName = true
  }

  confirmNameEdit() {
    const trimmed = (this.customerName || '').trim().slice(0, 100)
    this.customerName = trimmed || this.originalCustomerName
    this.isEditingName = false
  }

  async onConfirm() {
    if (this.userRegistering || !this.phoneNumber || (this.isNewUser && !this.customerName)) {
      return
    }
    if (this.showBirthdate) {
      if (this.checkBirthdate()) {
        this.$swal(
          constants.SOMETHING_WROING,
          'Tanggal Lahir tidak valid',
          constants.STATUS_ERROR
        )
        return
      }
    }

    this.userRegistering = true

    const posOrderOutlet = JSON.parse(
      localStorage.getItem('pos-order-outlet') || '{}'
    )
    let payload: any = {
      outletCode: posOrderOutlet.value.toString(),
      birthdateYear: this.birthdate.year ? this.birthdate.year.value : '',
      birthdateMonth: this.birthdate.month ? this.birthdate.month.value : '',
      birthdateDay: this.birthdate.day ? this.birthdate.day.value : '',
      gender: this.gender,
      ageRange: this.ageRange,
      ethnicity: this.ethnicityTagging.value || '',
      occasions: this.occasionTagging.value || [],
      treatmentTagging: this.treatmentTagging.value || [],
      foodPreferences: this.foodPreferenceTagging.value || [],
      memberStatus: this.memberStatus || 0,
      note: this.customerNote || ''
    }
    // Create new user and tagging
    if (this.isNewUser) {
      payload = {
        ...payload,
        name: this.customerName,
        phone: `${this.country.code}-${this.phoneNumber}`
      }
      api
        .PostUserRegister(payload)
        .then(res => {
          if (res.data.invalidMessage === constants.UPPER_SUCCESS) {
            this.userRegistered = true
            this.registeredInfo = {
              userId: res.data.data.data.user_id,
              name: this.customerName
            }
            this.originalCustomerName = this.customerName
            sessionStorage.setItem(
              'edc_step',
              this.constants.HOME_SCREEN_STEPS_CONFIG.posOrderPromo.key
            )
            this.showTaggingModal = false
            this.isNewUser = false
            this.isEditingNote = false
            this.skipCoupon = false
            this.currentStep = this.steps[this.getCurrentStepIndex() + 1].key
          } else if (res.data.invalidMessage === 'user exists') {
            this.onCheckUser()
          } else {
            this.$swal(
              constants.SOMETHING_WROING,
              res.data.invalidMessage,
              constants.STATUS_ERROR
            )
          }
        })
        .catch(e => {
          this.$swal(
            constants.SOMETHING_WROING,
            e.message,
            constants.STATUS_ERROR
          )
        })
    } else { // Update tagging
      if (this.userRegistered) {
        sessionStorage.setItem(
          'edc_step',
          this.constants.HOME_SCREEN_STEPS_CONFIG.posOrderPromo.key
        )
        const trimmedName = (this.customerName || '').trim()
        const nameChanged = !!trimmedName && trimmedName !== this.originalCustomerName
        payload = {
          ...payload,
          userId: this.registeredInfo.userId,
          ...(nameChanged ? { name: trimmedName } : {})
        }
        let renameFailed = false
        try {
          const res: any = await api.UpdateUserTagging(payload)
          const succeeded = res && res.data && res.data.invalidMessage === constants.UPPER_SUCCESS
          if (nameChanged) {
            if (succeeded) {
              this.registeredInfo = { ...this.registeredInfo, name: trimmedName }
              this.customerName = trimmedName
              this.originalCustomerName = trimmedName
            } else {
              renameFailed = true
              this.$swal(
                constants.SOMETHING_WROING,
                (res && res.data && res.data.invalidMessage) || '',
                constants.STATUS_ERROR
              )
            }
          }
        } catch (e) {
          if (nameChanged) {
            renameFailed = true
            this.$swal(
              constants.SOMETHING_WROING,
              (e as any).message,
              constants.STATUS_ERROR
            )
          } else {
            console.log(e)
          }
        }
        this.userRegistering = false
        if (renameFailed) {
          // Keep modal open so the user can retry or cancel the rename.
          return
        }
        this.isEditingName = false
        this.showTaggingModal = false
        this.skipCoupon = false
        this.currentStep = this.steps[this.getCurrentStepIndex() + 1].key
        return
      }
    }
    this.userRegistering = false
  }

  onCheckUser() {
    if (this.userChecking) {
      return
    }
    if (!this.phoneNumber || !this.validPhone) {
      this.userRegistered = false
      return
    }
    this.birthdate = {}
    this.gender = 0
    this.ageRange = ''
    this.memberStatus = 0
    this.ethnicityTagging.value = ''
    this.occasionTagging.value = []
    this.treatmentTagging.value = []
    this.foodPreferenceTagging.value = []
    this.isEditingNote = false
    this.isEditingName = false
    this.userChecking = true
    this.registeredInfo = {}
    this.milestoneData = null
    this.brandNew = false
    const posOrderOutlet = JSON.parse(
      localStorage.getItem('pos-order-outlet') || '{}'
    )
    api
      .CheckUserDetail(`${this.country.code}-${this.phoneNumber}`, posOrderOutlet.value.toString())
      .then((res: any) => {
        if (res.data.invalidMessage === constants.UPPER_SUCCESS) {
          const { result } = res.data.data
          this.userRegistered = result.registered
          this.brandNew = !!result.brand_new
          if (result.registered) {
            this.registeredInfo = {
              userId: result.user_id,
              name: result.name
            }
            if (!isEmpty(result.milestone) && result.milestone.levels && result.milestone.levels.length) {
              const previousLevel = Object.prototype.hasOwnProperty.call(result.milestone, 'level')
                ? result.milestone.level
                : ''
              const levelInfo = calculateLevelInfo(
                result.milestone.levels,
                result.milestone.total_sales || 0
              )
              this.milestoneData = {
                level: levelInfo.memberLevel,
                previousLevel: previousLevel || result.milestone.previous_level || '',
                progressLevel: levelInfo.memberLevel,
                total: result.milestone.total_sales || 0,
                period: result.milestone.period || '',
                tier_basis: result.milestone.tier_basis || 'spending',
                spendToNextLevel: levelInfo.spendToNextLevel,
                nextLevelName: levelInfo.nextLevelName
              }
            }
            this.birthdate = {
              year: this.getYearOptions.find(
                v => v.value === result.birthdateYear
              ),
              month: this.getMonthOptions.find(
                v => v.value === result.birthdateMonth
              ),
              day: this.getDayOptions.find(v => v.value === result.birthdateDay)
            }
            this.gender = result.gender
            this.ageRange = result.age_range
            this.memberStatus = result.member_status || 0
            this.ethnicityTagging.value = result.ethnicity || ''
            this.occasionTagging.value = result.occasions || []
            this.treatmentTagging.value = result.treatmentTagging || []
            this.foodPreferenceTagging.value = result.food_preferences || []
            this.showTaggingModal = true
            this.isNewUser = false
            this.customerNote = result.note || ''
            const backendName = (result.name || '').trim()
            this.customerName = backendName
            this.originalCustomerName = backendName
          } else {
            this.isNewUser = true
          }
          this.showTaggingModal = true
        } else {
          this.userRegistered = false
          this.$swal(
            constants.SOMETHING_WROING,
            res.data.message,
            constants.STATUS_ERROR
          )
        }
      })
      .catch(err => {
        this.userRegistered = false
        this.$swal(
          constants.SOMETHING_WROING,
          err.message,
          constants.STATUS_ERROR
        )
      })
      .finally(() => {
        this.userChecking = false
        // this.scrollToTop('taggingModal')
      })
  }

  calculateOrder() {
    if (this.disableCheckout) {
      return
    }
    const posOrderOutlet = JSON.parse(
      localStorage.getItem('pos-order-outlet') || '{}'
    )
    if (this.coupon.id && this.phoneNumber && Number(this.total_payment)) {
      this.isCalculating = true
      api
        .BoCalCulateOrder({
          orderType: 'POS',
          orderSource: 'BO',
          payment: [
            {
              paymentAmount: Number(this.total_payment)
            }
          ],
          destinationStore: {
            outletCode: posOrderOutlet.value.toString()
          },
          requestId: getRequestId(),
          contact: {
            phone: `${this.country.code}-${this.phoneNumber}`
          },
          has_processing_fee: this.has_processing_fee,
          promo_id: this.coupon.id,
          referral_type: this.coupon.referral_type,
          referral_user_type: this.coupon.referral_user_type
        })
        .then(res => {
          const message = (res.data as any).invalidMessage
          if (message !== constants.UPPER_SUCCESS) {
            this.$swal(
              constants.SOMETHING_WROING,
              message,
              constants.STATUS_ERROR
            )
            return
          }
          try {
            const { couponUseResult, orderCalculations } = res.data.data
            if (couponUseResult !== constants.STATUS_SUCCESS) {
              this.$swal(
                constants.SOMETHING_WROING,
                couponUseResult,
                constants.STATUS_ERROR
              )
              this.coupon = {}
              this.paymentDetail = {}
              return
            }
            const paymentDetail: any = {}
            for (let i = 0; i < orderCalculations.length; i++) {
              const element = orderCalculations[i]
              paymentDetail[element.key] = element.value
            }
            this.paymentDetail = paymentDetail
          } catch (error) {
          }
        })
        .finally(() => {
          this.isCalculating = false
        })
    } else {
      this.paymentDetail = {}
    }
  }

  @Watch('userRegistered')
  watchUserRegistered() {
    // Name baselines for registered users are seeded inside onCheckUser
    // (single source of truth). Keep this watcher a no-op to avoid racing
    // with that seeding.
  }

  @Watch('phoneNumber')
  watchPhoneNumber() {
    let phoneStep = this.steps.findIndex(
      (step) => step.key === this.constants.HOME_SCREEN_STEPS_CONFIG.posOrderPromo.key
    )
    if (this.getCurrentStepIndex() <= phoneStep) {
      this.userRegistered = false
    }
    if (this.coupon.id) {
      this.coupon = {}
      this.debounceCalculate()
    }
    if (!this.phoneNumber) return (this.validPhone = true)
    if (
      this.country.code === '+62' &&
      (this.phoneNumber.length > 15 ||
        this.phoneNumber.length < 9 ||
        (this.phoneNumber &&
          (take(this.phoneNumber, 2).join('') !== '08' &&
            this.phoneNumber[0] !== '8')))
    ) {
      this.validPhone = false
    } else {
      this.validPhone = true
    }
  }

  @Watch('country.code')
  watchCountry() {
    this.watchPhoneNumber()
  }

  showDetailHandle() {
    this.showDetail = !this.showDetail
  }

  @Watch('has_processing_fee')
  watchHasProcessingFee() {
    if (this.has_processing_fee === 0) {
      this.custom_total_payment = Number(this.total_payment)
      this.showProcessingFee = false
    } else {
      if (Number(this.total_payment) > 0) {
        this.showProcessingFee = true
        this.custom_total_payment =
          Number(this.total_payment) + this.processing_fee
      }
    }
    this.debounceCalculate()
  }

  @Watch('currentStep')
  watchStep() {
    if (this.currentStep === constants.HOME_SCREEN_STEPS_CONFIG.posOrderPromo.key && !!this.phoneNumber && !this.skipCoupon) {
      this.getCoupons()
    }
  }

  @Watch('total_payment')
  watchTotalPayment() {
    if (Number(this.total_payment) > 0) {
      this.showSubTotal = true
      if (this.has_processing_fee === 1) {
        this.custom_total_payment =
          Number(this.total_payment) + this.processing_fee
        this.showProcessingFee = true
      } else {
        this.showProcessingFee = false
        this.custom_total_payment = Number(this.total_payment)
      }
    } else {
      this.showSubTotal = false
      this.showProcessingFee = false
      this.custom_total_payment = 0
    }
    this.debounceCalculate()
  }

  changePayment(value) {
    this.selectedPayment = this.options.filter(item => item.value === value)[0]
    this.payment = value
    this.nextStep()
  }

  mounted() {
    // handle go back
    if (window.history && window.history.pushState) {
      history.pushState(null, '', document.URL)
      window.addEventListener('popstate', this.hidePosOrder, false)
    }
    const outletData = JSON.parse(localStorage.getItem('outletData') || '{}')
    const {
      is_pos_input,
      payment_method,
      banner_image,
      store_configuration,
      edc_qris,
      edc_online_payment,
      edc_cimb_payment,
      edc_offline_payment,
      edc_order_flow_type,
      processing_fee,
      user_note_active,
      phone_input_required,
      brand_new_customer_treatment
    } = outletData

    this.storeConfiguration = store_configuration
    this.phoneInputRequired = !!phone_input_required
    this.brandNewCustomerTreatment = !!brand_new_customer_treatment
    if (edc_order_flow_type === 1) {
      this.steps = constants.HOME_SCREEN_STEPS_PHONE_FIRST
    }
    if (this.modelType) {
      this.currentStep = constants.HOME_SCREEN_STEPS_CONFIG.posOrderPhone.key
    } else {
      if (store_configuration && store_configuration.staff_pin_valid) {
        this.currentStep = constants.HOME_SCREEN_STEPS_CONFIG.transaksiMember.key
      } else {
        this.currentStep = this.steps[1].key
      }
    }
    this.userNoteActive = store_configuration && store_configuration.user_note_active
    this.payment_method = payment_method
    this.bannerImage = banner_image
    if (is_pos_input === 1 && edc_qris === 1) {
      if (payment_method === 'Midtrans') {
        this.options.push(
          {
            value: 'Qris-GoPay',
            text: 'QRIS Gopay',
            type: 'qris',
            img: require('@/assets/edc/qris-payment.png')
          },
          {
            value: 'Qris-ShopeePay',
            text: 'QRIS Shopee Pay',
            type: 'qris',
            img: require('@/assets/edc/qris-payment.png')
          }
        )
      } else if (payment_method === 'Astrapay') {
        this.options.push({
          value: 'Astrapay',
          text: 'QRIS AstraPay',
          type: 'qris',
          img: require('@/assets/edc/qris-payment.png')
        })
      } else {
        this.options.push({
          value: 'QRPay',
          text: 'QRIS CIMB',
          type: 'qris',
          img: require('@/assets/edc/qris-payment.png')
        })
      }
    }
    if (!isEmpty(edc_online_payment)) {
      if (edc_online_payment.ottopay) {
        this.options.push({
          value: 'QR',
          text: 'QRIS Ottopay',
          type: 'qris',
          img: require('@/assets/edc/qris-payment.png')
        })
      }
      if (edc_online_payment.debit) {
        this.options.push({
          value: 'DEBITCARD',
          text: 'Debit Card',
          type: 'card',
          img: require('@/assets/edc/card-payment.png')
        })
      }
      if (edc_online_payment.credit) {
        this.options.push({
          value: 'CREDITCARD',
          text: 'Credit Card',
          type: 'card',
          img: require('@/assets/edc/card-payment.png')
        })
      }
    }
    if (!isEmpty(edc_cimb_payment)) {
      if (edc_cimb_payment.qris) {
        this.options.push({
          value: 'CIMB-QR',
          text: 'QRIS EDC CIMB',
          type: 'qris',
          img: require('@/assets/edc/qris-payment.png')
        })
      }
      if (edc_cimb_payment.debit) {
        this.options.push({
          value: 'CIMB-DEBIT',
          text: 'CIMB Debit Card',
          type: 'card',
          img: require('@/assets/edc/card-payment.png')
        })
      }
      if (edc_cimb_payment.credit) {
        this.options.push({
          value: 'CIMB-CREDIT',
          text: 'CIMB Credit Card',
          type: 'card',
          img: require('@/assets/edc/card-payment.png')
        })
      }
    }
    if (!isEmpty(edc_offline_payment)) {
      const edOfflinePayment = constants.EDC_OFFLINE_PAYMENT_OPTIONS.filter(
        item => !!edc_offline_payment[item.key]
      )
      this.options.push(...edOfflinePayment)
    }

    this.ageRangeOptions = constants.DEFAULT_AGE_RANGE
    if (store_configuration) {
      this.showTagging = store_configuration.show_tagging
      this.showBirthdate = store_configuration.birthdate_display
      this.genderTaggingActive = store_configuration.gender_tagging_active
      this.ageRangeTaggingActive = store_configuration.age_range_tagging_active
      this.memberStatusTaggingActive = store_configuration.member_status_tagging_active
      const ethnicityTaggingVal = get(
        store_configuration,
        'ethnicity_tagging',
        '{}'
      )
      if (ethnicityTaggingVal && ethnicityTaggingVal !== '{}') {
        const ethnicityTagging = JSON.parse(ethnicityTaggingVal)
        this.ethnicityTagging = {
          ...this.ethnicityTagging,
          active: !!get(ethnicityTagging, 'active', false),
          options: get(ethnicityTagging, 'options', [])
        }
      }
      const occasionTaggingVal = get(
        store_configuration,
        'occasions_tagging',
        '{}'
      )
      if (occasionTaggingVal && occasionTaggingVal !== '{}') {
        const occasionTagging = JSON.parse(occasionTaggingVal)
        this.occasionTagging = {
          ...this.occasionTagging,
          active: !!get(occasionTagging, 'active', false),
          isMultiple: !!get(occasionTagging, 'isMultiple', false),
          options: get(occasionTagging, 'options', [])
        }
      }
      const treatmentTaggingVal = get(
        store_configuration,
        'treatment_tagging',
        '{}'
      )
      if (treatmentTaggingVal && treatmentTaggingVal !== '{}') {
        const treatmentTagging = JSON.parse(treatmentTaggingVal)
        this.treatmentTagging = {
          ...this.treatmentTagging,
          active: !!get(treatmentTagging, 'active', false),
          isMultiple: !!get(treatmentTagging, 'isMultiple', false),
          options: get(treatmentTagging, 'options', [])
        }
      }
      const foodPreferenceTaggingVal = get(
        store_configuration,
        'food_preferences_tagging',
        '{}'
      )
      if (foodPreferenceTaggingVal && foodPreferenceTaggingVal !== '{}') {
        const foodPreferenceTagging = JSON.parse(foodPreferenceTaggingVal)
        this.foodPreferenceTagging = {
          ...this.foodPreferenceTagging,
          active: !!get(foodPreferenceTagging, 'active', false),
          options: get(foodPreferenceTagging, 'options', [])
        }
      }
      if (
        store_configuration.age_range &&
        store_configuration.age_range.split(',').length
      ) {
        this.ageRangeOptions = store_configuration.age_range.split(',')
      }
    }

    this.qrisOptions = this.options.filter(item => item.type === 'qris')
    this.cardOptions = this.options.filter(item => item.type === 'card')
    this.otherOptions = this.options.filter(item => item.type === 'other')

    this.processing_fee = get(processing_fee, 'POS', 0)
    const sessionEdcStep = sessionStorage.getItem('edc_step')
    const sessionClickedKembali = sessionStorage.getItem('clicked_kembali')
    if (sessionEdcStep && sessionClickedKembali) {
      const sessionEdcStep = sessionStorage.getItem('edc_step')
      const sessionCouponsPayloadCountry = sessionStorage.getItem(
        'coupons_payload_country'
      )
      const sessionCouponsPayloadPhoneNumber = sessionStorage.getItem(
        'coupons_payload_phoneNumber'
      )
      const sessionPageState = sessionStorage.getItem('edc_page_states')
      if (sessionCouponsPayloadCountry) {
        this.country = JSON.parse(sessionCouponsPayloadCountry)
      }
      if (sessionCouponsPayloadPhoneNumber) {
        this.phoneNumber = sessionCouponsPayloadPhoneNumber
      }
      if (sessionPageState) {
        const parsedsessionPageState = JSON.parse(sessionPageState)
        this.payment = parsedsessionPageState.payment
        this.customerName = parsedsessionPageState.customerName
        const restoredRegisteredName = parsedsessionPageState.userRegistered && parsedsessionPageState.registeredInfo
          ? parsedsessionPageState.registeredInfo.name
          : ''
        this.originalCustomerName = parsedsessionPageState.originalCustomerName || restoredRegisteredName || parsedsessionPageState.customerName || ''
        this.isEditingName = parsedsessionPageState.isEditingName || false
        this.phoneNumber = parsedsessionPageState.phoneNumber
        this.customerNote = parsedsessionPageState.customerNote || ''
        this.showDetail = parsedsessionPageState.showDetail
        this.paymentDetail = parsedsessionPageState.paymentDetail
        this.discount_name = parsedsessionPageState.discount_name
        this.has_processing_fee = parsedsessionPageState.has_processing_fee
        this.showProcessingFee = parsedsessionPageState.showProcessingFee
        this.showSubTotal = parsedsessionPageState.showSubTotal
        this.country = parsedsessionPageState.country
        this.validPhone = parsedsessionPageState.validPhone
        this.options = parsedsessionPageState.options
        this.qrisOptions = parsedsessionPageState.qrisOptions
        this.cardOptions = parsedsessionPageState.cardOptions
        this.otherOptions = parsedsessionPageState.otherOptions
        this.selectedPayment = parsedsessionPageState.selectedPayment
        this.custom_total_payment = parsedsessionPageState.custom_total_payment
        this.total_payment = parsedsessionPageState.total_payment
        this.processing_fee = parsedsessionPageState.processing_fee
        this.constants = parsedsessionPageState.constants
        this.payment_method = parsedsessionPageState.payment_method
        this.fetchingCoupons = parsedsessionPageState.fetchingCoupons
        this.coupon = parsedsessionPageState.coupon
        this.showCouponModal = parsedsessionPageState.showCouponModal
        this.coupons = parsedsessionPageState.coupons
        this.bannerImage = parsedsessionPageState.bannerImage
        this.userChecking = parsedsessionPageState.userChecking
        this.userRegistering = parsedsessionPageState.userRegistering
        this.showTaggingModal = parsedsessionPageState.showTaggingModal
        this.isNewUser = parsedsessionPageState.isNewUser
        this.userRegistered = parsedsessionPageState.userRegistered
        this.registeredInfo = parsedsessionPageState.registeredInfo
        this.showTagging = parsedsessionPageState.showTagging
        this.showBirthdate = parsedsessionPageState.showBirthdate
        this.birthdate = parsedsessionPageState.birthdate
        this.gender = parsedsessionPageState.gender
        this.ageRange = parsedsessionPageState.ageRange
        this.currentStep = sessionEdcStep || ''
        this.skipCoupon = parsedsessionPageState.skipCoupon || false
      }
      sessionStorage.removeItem('edc_step')
      sessionStorage.removeItem('clicked_kembali')
      sessionStorage.removeItem('edc_page_states')
    }
  }

  destroyed() {
    window.removeEventListener('popstate', this.hidePosOrder, false)
    this.submitLoading = false
  }

  getCurrentStepIndex() {
    return this.steps.findIndex(step => step.key === this.currentStep)
  }

  nextStep(isBack = false) {
    const currentIndex = this.getCurrentStepIndex()
    if (currentIndex === -1) return

    if (isBack) {
      if (currentIndex > 0) {
        this.currentStep = this.steps[currentIndex - 1].key
        if (this.currentStep === constants.HOME_SCREEN_STEPS_CONFIG.posOrderPromo.key && this.skipCoupon) {
          this.currentStep = this.steps[currentIndex - 2].key
        }
      }
    } else {
      if (this.currentStep === constants.HOME_SCREEN_STEPS_CONFIG.posOrderPhone.key) {
        this.onCheckUser()
        return
      }
      if (currentIndex < this.steps.length - 1) {
        this.currentStep = this.steps[currentIndex + 1].key
      }
    }

    this.scrollToTop('posOrderContainer')
  }

  scrollToTop(refKey: string) {
    if ((this.$refs as any)[refKey]) {
      // console.log('scrollToTop', this.$refs[refKey].$el)
      (this.$refs[refKey] as any).scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }

  skipCheckUser() {
    this.skipCoupon = true
    if (this.steps[this.steps.length - 2].key === constants.HOME_SCREEN_STEPS_CONFIG.posOrderPhone.key) {
      this.userRegistered = false
      this.registeredInfo = {}
      this.checkOrderSubmit()
    } else {
      this.currentStep = this.steps[this.getCurrentStepIndex() + 2].key
    }
  }

  submitHandle() {
    if (this.disableCheckout || this.submitLoading || this.isCalculating) {
      return
    }
    sessionStorage.removeItem('isPos')
    sessionStorage.setItem('pos-order-page', this.$route.fullPath)
    const outletData = JSON.parse(localStorage.getItem('outletData') || '{}')
    const posOrderOutlet = JSON.parse(
      localStorage.getItem('pos-order-outlet') || '{}'
    )
    this.submitLoading = true
    const MerchantName = localStorage.getItem('UserName')
    const pinCode = sessionStorage.getItem('pin_code') || undefined
    const defaultUserId = constants.DEFAULT_USER_ID
    const defaultPhone = '0888888888'
    const paymentAmount = Number(this.total_payment || 0)
    const userId =
      this.userRegistered && this.registeredInfo.userId
        ? this.registeredInfo.userId.toString()
        : defaultUserId
    const phoneFullNo = `${this.country.code}-${
      this.userRegistered ? this.phoneNumber : defaultPhone
    }`
    const phoneNo = this.userRegistered ? this.phoneNumber : defaultPhone
    const userName = this.userRegistered
      ? this.registeredInfo.name
      : MerchantName
    sessionStorage.setItem(
      'edc_page_states',
      JSON.stringify({
        payment: this.payment,
        customerName: this.customerName,
        originalCustomerName: this.originalCustomerName,
        isEditingName: this.isEditingName,
        phoneNumber: this.phoneNumber,
        customerNote: this.customerNote,
        showDetail: this.showDetail,
        paymentDetail: this.paymentDetail,
        discount_name: this.discount_name,
        has_processing_fee: this.has_processing_fee,
        showProcessingFee: this.showProcessingFee,
        showSubTotal: this.showSubTotal,
        country: this.country,
        validPhone: this.validPhone,
        options: this.options,
        qrisOptions: this.qrisOptions,
        cardOptions: this.cardOptions,
        otherOptions: this.otherOptions,
        selectedPayment: this.selectedPayment,
        custom_total_payment: this.custom_total_payment,
        total_payment: this.total_payment,
        processing_fee: this.processing_fee,
        constants: this.constants,
        payment_method: this.payment_method,
        fetchingCoupons: this.fetchingCoupons,
        coupon: this.coupon,
        showCouponModal: this.showCouponModal,
        coupons: this.coupons,
        bannerImage: this.bannerImage,
        currentStep: this.currentStep,
        userChecking: this.userChecking,
        userRegistering: this.userRegistering,
        showTaggingModal: this.showTaggingModal,
        isNewUser: this.isNewUser,
        userRegistered: this.userRegistered,
        registeredInfo: this.registeredInfo,
        showTagging: this.showTagging,
        showBirthdate: this.showBirthdate,
        birthdate: this.birthdate,
        gender: this.gender,
        ageRange: this.ageRange,
        skipCoupon: this.skipCoupon
      })
    )
    const orderPayload: any = {
      userId,
      orderType: 'POS',
      orderSource: 'BO',
      TableNo: '',
      promo_value: 0,
      custom_total_payment: paymentAmount,
      discount_name: '',
      payment: [
        {
          paymentAmount,
          paymentUsed: 0,
          paymentMethodCode: this.payment
        }
      ],
      destinationStore: { outletCode: String(posOrderOutlet.value) },
      orderLines: [],
      requestId: this.orderRequestId || (this.orderRequestId = getRequestId()),
      user: {
        qravedUserID: userId,
        name: userName,
        phoneNo: phoneFullNo,
        id: userId
      },
      posOrderId: this.posOrderId || undefined,
      pin_code: pinCode,
      notes: '',
      contact: {
        phone: phoneFullNo,
        name: userName
      },
      has_processing_fee: this.has_processing_fee,
      promo_id: this.coupon && this.coupon.id ? this.coupon.id : undefined,
      referral_code:
        this.coupon && this.coupon.referral_code
          ? this.coupon.referral_code
          : undefined,
      referral_type:
        this.coupon && this.coupon.referral_type
          ? this.coupon.referral_type
          : undefined,
      referral_user_type:
        this.coupon && this.coupon.referral_user_type
          ? this.coupon.referral_user_type
          : undefined,
      commission:
        this.coupon && this.coupon.commission
          ? this.coupon.commission
          : undefined,
      referral_campaign_id:
        this.coupon && this.coupon.referral_campaign_id
          ? this.coupon.referral_campaign_id
          : undefined
    }
    if (this.isTestMode) {
      orderPayload.test_mode = 1
    }
    api
      .BoPosOrder(orderPayload)
      .then(res => {
        if (res.data.code !== constants.STATUS_200_STRING) {
          this.submitLoading = false
          this.orderRequestId = ''
          if (res.data.message === constants.FAILED_COUPON) {
            this.coupon = {}
            this.paymentDetail = {}
          }
          return this.$swal(
            constants.SOMETHING_WROING,
            res.data.message,
            constants.STATUS_ERROR
          )
        }
        if (res.data.invalidMessage !== constants.UPPER_SUCCESS) {
          this.submitLoading = false
          this.orderRequestId = ''
          return this.$swal(
            res.data.errCode === constants.SOMETHING_SORRY_ID
              ? constants.SOMETHING_SORRY_MESSAGE
              : constants.SOMETHING_WROING,
            res.data.invalidMessage,
            constants.STATUS_ERROR
          )
        }
        const data = res.data.data
        if (openOttoPay(this, data)) return

        if (data.paymentSuccess) {
          this.orderRequestId = ''
          sessionStorage.setItem('payCallBackInfo', JSON.stringify(data))
          sessionStorage.setItem(
            'cartListInfo',
            JSON.stringify({
              isFree: true,
              selectedPayment: {
                text: this.payment
              },
              posOrderInput: {
                active: outletData.pos_active,
                posName: outletData.pos_name,
                mandatory: outletData.pos_order_required
              }
            })
          )
          sessionStorage.setItem('orderId', data.orderId)
          this.$router.push('/pos-result')
          return
        }
        let qrCode = ''
        if (constants.QR_TYPE.includes(this.payment)) {
          if (this.payment === 'Astrapay') {
            qrCode = data.qrData.qrContent
          } else {
            qrCode =
              this.payment_method === 'Midtrans'
                ? data.qrData.qr_string
                : data.qrData.data.qrCode
          }
        }

        if (qrCode) {
          this.orderRequestId = ''
          sessionStorage.setItem('payCallBackInfo', JSON.stringify(data))
          sessionStorage.setItem('orderId', data.orderId)
          sessionStorage.setItem('qrCode', qrCode)
          sessionStorage.setItem(
            'cartListInfo',
            JSON.stringify({
              cartList: [],
              promo_value: 0,
              promo_type: 0,
              has_service_fee: 0,
              has_tax: 0,
              discount_name: 0,
              payment_method: this.payment_method,
              payment: this.payment,
              phoneNumber: phoneNo,
              country: this.country,
              customerName: userName,
              totalSales: data.totalSales,
              notes: '',
              selectedPayment: this.selectedPayment,
              posOrderInput: {
                active: outletData.pos_active,
                posName: outletData.pos_name,
                mandatory: outletData.pos_order_required
              }
            })
          )
          sessionStorage.setItem('isPos', '1')
          sessionStorage.removeItem('leftTime')
          this.$router.push(`/pos-qr`)
          return
        }
        if (window && typeof (window as any).android !== 'undefined') {
          if (this.payment === 'CIMB-QR') {
            (window as any).android.payWithCimbApp(
              data.orderId,
              data.totalSales,
              'QRMPM'
            )
          } else if (this.payment === 'CIMB-DEBIT' || this.payment === 'CIMB-CREDIT') {
            (window as any).android.payWithCimbApp(
              data.orderId,
              data.totalSales,
              'SALE'
            )
          } else {
            (window as any).android.payAtCashier(
              data.orderId,
              this.payment,
              data.totalSales,
              getEdcMidMapping()
            )
          }
        }
        setTimeout(() => {
          this.orderRequestId = ''
          sessionStorage.removeItem('leftTime')
          sessionStorage.setItem('payCallBackInfo', JSON.stringify(data))
          sessionStorage.setItem(
            'cartListInfo',
            JSON.stringify({
              isDevice: true,
              selectedPayment: {
                text: this.payment
              },
              posOrderInput: {
                active: outletData.pos_active,
                posName: outletData.pos_name,
                mandatory: outletData.pos_order_required
              }
            })
          )
          sessionStorage.setItem('orderId', data.orderId)
          this.$router.push('/pos-result')
        }, 2000)
      })
      .catch(err => {
        this.orderRequestId = ''
        this.$swal(
          constants.SOMETHING_WROING,
          err.message,
          constants.STATUS_ERROR
        )
        this.submitLoading = false
        throw err
      })

    sessionStorage.setItem('edc_step', `${this.currentStep}`)
  }

  changeCustomTotalPayment(event) {
    const val = Number(event).toString()
    this.total_payment = val || '0'
    if (Number(val) > constants.MAX_PRICE) {
      this.total_payment = '0'
      setTimeout(() => {
        this.total_payment = constants.MAX_PRICE.toString()
      })
    }
    if (Number(val) < 0) {
      this.total_payment = '0'
    }
  }

  confirmPayment() {
    this.reload()
    this.hidePosOrder()
  }

  async getCoupons() {
    const posOrderOutlet = JSON.parse(
      localStorage.getItem('pos-order-outlet') || '{}'
    )
    this.fetchingCoupons = true
    sessionStorage.setItem(
      'coupons_payload_country',
      JSON.stringify(this.country)
    )
    sessionStorage.setItem('coupons_payload_phoneNumber', this.phoneNumber)
    api
      .GetCouponList(
        posOrderOutlet.value,
        'POS',
        `${this.country.code}-${this.phoneNumber}`
      )
      .then((res: any) => {
        if (res.data.invalidMessage === constants.UPPER_SUCCESS) {
          this.coupons = res.data.data.result
        } else {
          this.coupons = []
        }
      })
      .catch(() => {
        this.coupons = []
      })
      .finally(() => {
        this.fetchingCoupons = false
      })
  }

  setCouponHandle(item) {
    if (this.disableCheckout) {
      return
    }
    if (item.id === this.coupon.id) {
      this.coupon = item
      return
    }
    this.coupon = item
    this.debounceCalculate()
  }

  hideCouponHandle() {
    this.showCouponModal = false
  }

  checkOrderSubmit() {
    const outletData = JSON.parse(localStorage.getItem('outletData') || '{}')
    if (outletData.pos_active === 1 && outletData.pos_order_required === 1) {
      this.showPosOrderPopup = true
    } else {
      this.submitHandle()
    }
  }

  posOrderPopup(value) {
    this.showPosOrderPopup = value
  }

  posOrderValue(value) {
    this.posOrderId = value
    this.submitHandle()
  }
}
